"use client";

import { ChevronRight } from "lucide-react";
import { useAuth0 } from "@auth0/auth0-react";

export function Hero() {
  const { loginWithRedirect } = useAuth0();

  return (
    <section className="pt-24 md:pt-32 px-4 container mx-auto">
      <div className="flex flex-col md:flex-row items-center justify-between gap-12">
        <div className="md:w-1/2">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            TRANSFORME SUA{" "}
            <span className="text-gray-900 dark:text-gray-200 font-black animate-pulse">
              PLANILHA
            </span>{" "}
            EM UMA PLATAFORMA{" "}
            <span className="text-gray-900 dark:text-gray-200 font-black animate-pulse">
              PROFISSIONAL
            </span>
          </h2>
          <p className="text-white/90 text-lg mb-8">
            Gerencie pedidos, finanças e clientes em uma única plataforma
            intuitiva. Ideal para confeiteiras e pequenos empreendedores que
            querem profissionalizar seu negócio.
          </p>
          <button
            className="bg-gradient-to-r from-[#FF9A3C] to-[#EE7B11] text-white px-8 py-4 rounded-full text-lg font-bold hover:shadow-lg hover:shadow-[#EE7B11]/30 transition-all duration-300 transform hover:-translate-y-1 flex items-center gap-2"
            onClick={() => loginWithRedirect()}
          >
            EXPERIMENTE GRÁTIS <ChevronRight className="animate-bounce" />
          </button>
        </div>
        <div className="md:w-1/2">
          <picture>
            <source
              srcSet="/dash-landing-page-mobile.webp"
              type="image/webp"
              media="(max-width: 767px)"
            />
            <source srcSet="/dash-landing-page.webp" type="image/webp" />
            <img
              src="/dash-landing-page.webp"
              alt="Dashboard Preview"
              fetchPriority="high"
              className="rounded-lg shadow-2xl transform hover:scale-105 transition-transform duration-500 animate-float"
            />
          </picture>
        </div>
      </div>
    </section>
  );
}
